"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserRelationship = getUserRelationship;
/**
 * Gets the relationship of the user in the circle.
 */
function getUserRelationship(circle, userId) {
    var _a;
    if (((_a = circle === null || circle === void 0 ? void 0 : circle.relationships) === null || _a === void 0 ? void 0 : _a.length) && userId) {
        return circle.relationships.find(({ caregiverId }) => caregiverId === userId);
    }
}
//# sourceMappingURL=getUserRelationship.js.map